import React, { createContext, useContext, useMemo, useState } from "react";

import { ShortTermDisabilityPlan, PlanCost } from "Utils/types";

import { useModal } from "Cobalt/Modal";

interface OpenEnrollmentModalProps {
  plan: ShortTermDisabilityPlan;
  planCost: PlanCost;
}
interface ShortTermDisabilityContextProps {
  openEnrollmentModal: (props: OpenEnrollmentModalProps) => void;
  plan: ShortTermDisabilityPlan | null;
  planCost: PlanCost | null;
  isShowing: boolean;
  hideEnrollmentModal: () => void;
}

const ShortTermDisabilityContext = createContext<ShortTermDisabilityContextProps>({
  openEnrollmentModal: () => {},
  plan: null,
  planCost: null,
  isShowing: false,
  hideEnrollmentModal: () => {},
});

interface OpenEnrollmentModalProps {
  plan: ShortTermDisabilityPlan;
  planCost: PlanCost;
}
export const ShortTermDisabilityContextProvider = ({ children }) => {
  const { show, hide, isShowing } = useModal();
  const [_plan, _setPlan] = useState<ShortTermDisabilityPlan | null>(null);
  const [_planCost, _setPlanCost] = useState<PlanCost | null>(null);
  const contextValue = useMemo(() => {
    const openEnrollmentModal = ({ plan, planCost }: OpenEnrollmentModalProps) => {
      _setPlan(plan);
      _setPlanCost(planCost);
      show();
    };
    const hideEnrollmentModal = () => {
      _setPlan(null);
      _setPlanCost(null);
      hide();
    };

    return { openEnrollmentModal, plan: _plan, planCost: _planCost, isShowing, hideEnrollmentModal };
  }, [_plan, _planCost, isShowing, show, hide]);

  return <ShortTermDisabilityContext.Provider value={contextValue}>{children}</ShortTermDisabilityContext.Provider>;
};

export const useShortTermDisabilityContext = () => useContext(ShortTermDisabilityContext);
